import React from 'react';

import { ActionIcon, Group, Menu, px, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconDotsVertical } from '@tabler/icons-react';
import { OtherWorkType } from 'types';

import ModalDeleteOtherWorkType from './ModalDeleteOtherWorkType';
import ModalEditOtherWorkType from './ModalEditOtherWorkType';

interface IOtherWorkTypeTableHeaderProps {
  permission?: boolean;
  otherWorkType: OtherWorkType;
}

const OtherWorkTypeTableHeader = ({
  otherWorkType,
  permission = true,
}: IOtherWorkTypeTableHeaderProps): JSX.Element => {
  const theme = useMantineTheme();
  const [editModalOpened, { open: openEditModal, close: clodeEditModal }] = useDisclosure(false);
  const [deleteModalOpened, { open: openDeleteModal, close: closeDeleteModal }] = useDisclosure(false);

  return (
    <td style={{ width: `${px(theme.spacing.xl) * 10}px` }}>
      <Group position='apart'>
        {otherWorkType.name}
        <Menu position='bottom-end'>
          <Menu.Target>
            <ActionIcon
              data-cy='actionOtherWorkTypeButton'
              variant='subtle'
              onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.stopPropagation()}
              disabled={!permission}
            >
              <IconDotsVertical size={theme.fontSizes.md} fill={theme.white} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item onClick={openEditModal}>Edit</Menu.Item>
            <Menu.Item onClick={openDeleteModal}>Delete</Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
      <ModalEditOtherWorkType
        opened={editModalOpened}
        handleClose={clodeEditModal}
        otherWorkType={otherWorkType}
      />
      <ModalDeleteOtherWorkType
        opened={deleteModalOpened}
        handleClose={closeDeleteModal}
        otherWorkTypeId={otherWorkType.otherWorkTypeId}
      />
    </td>
  );
};

export default OtherWorkTypeTableHeader;
